import { Box, Container, styled } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import BalanceCard from 'components/BalanceCard';

export const StyledBox = styled(Box)`
  width: 100%;
  flex-direction: column;
  padding-top: 2rem;
`;

export const StyledContainer = styled(Container)`
  margin-top: 3rem;
  padding-bottom: 4rem !important;
  position: relative;
  width: 90%;

  ${theme.breakpoints.up('md')} {
    width: 80%;
  }
`;

export const StyledBalanceCard = styled(BalanceCard)`
  margin: 1rem 0;
`;
